import {
    getContactType,
    getContactTypeId,
    getDataMapper,
    mapField,
    mapArray,
} from "../../../lib";
export const mapContactFromServer = getDataMapper({
    id: mapField("id", Number),
    value: mapField("value"),
    isConfirmed: mapField("confirmed", Boolean),
    contactType: getContactType,
    contactTypeId: getContactTypeId,
});

export const mapContactsFromServer = mapArray(mapContactFromServer);
